<mat-form-field [class.autocompletable]="autocomplete === 'on'"
                appearance="fill"
                [class.form-slim]="slim">
    <mat-label>{{label}}</mat-label>

    <input (ngModelChange)="write(txt, $event)"
           [autocomplete]="autocomplete"
           [disabled]="disabled"
           [name]="name"
           [ngModel]="value"
           [attr.maxLength]="maxLength"
           [placeholder]="placeholder"
           [errorStateMatcher]="errorStateMatcher"
           [required]="required"
           [type]="type"
           #txt
           matInput="">
    <mat-icon *ngIf="suffixIconClass" [ngClass]="suffixIconClass" matSuffix></mat-icon>
    <mat-error *ngFor="let error of (errorStateMatcher ? errorStateMatcher.errors : [])">
        {{ error.description ? error.description : error.code }}
    </mat-error>
</mat-form-field>
